import { inject, Injectable } from '@angular/core';
import { DateTimeService } from '@examdojo/core/date-time';
import { AbstractDialogService, DialogOptions } from '@examdojo/core/dialog';
import { EMPTY, filter, from, switchMap } from 'rxjs';
import { AssessmentUIModel } from '../assessment.model';
import { AssessmentService } from '../assessment.service';
import { AssessmentFormDialogComponent } from './assessment-form-dialog.component';
import { AssessmentFormModel } from './assessment-form-dialog.model';

export const ASSESSMENT_FORM_DIALOG_ID = 'assessment-form-dialog';

@Injectable({ providedIn: 'root' })
export class AssessmentFormDialogService extends AbstractDialogService<
  AssessmentUIModel,
  AssessmentFormModel,
  typeof AssessmentFormDialogComponent
> {
  readonly assessmentService = inject(AssessmentService);
  readonly dateTimeService = inject(DateTimeService);

  readonly id = ASSESSMENT_FORM_DIALOG_ID;
  protected readonly component = AssessmentFormDialogComponent;

  protected override readonly options: DialogOptions = {
    cssClass: 'fullscreen',
    showBackdrop: false,
    handle: false,
  };

  override openDialog(config?: { input: AssessmentUIModel; options?: DialogOptions }) {
    this.componentProps.assessment = config?.input;

    return super.openDialog(config);
  }

  openDialogAndUpdateAssessment(assessment: AssessmentUIModel) {
    return from(this.openDialog({ input: assessment })).pipe(
      filter(Boolean),
      switchMap((output) => {
        const targetDate = output.basicInfo.date;
        const utcTargetDate = new Date(
          Date.UTC(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate(), 12),
        );

        return this.assessmentService.update(
          assessment.id,
          {
            title: output.basicInfo.name,
            active: output.basicInfo.isActive,
            target_date: utcTargetDate.toISOString(),
            assessment_type: output.typeSelection.assessmentType[0],
          },
          output.tl2Selection.selectedTopics.map((value) => Number(value)),
        );
      }),
      this.errorHandlerService.catchHttpErrors(() => EMPTY),
    );
  }
}
